import React, {useState, useEffect} from 'react'
import Select from "react-select";
import {useLocation, useNavigate} from "react-router-dom";

const locations = [
    { value: '', label: 'All'},
    { value: '1487 5th Avenue', label: '1487 5th Avenue, Troy, NY'},
    { value: '172 River Street', label: '172 River Street, Troy, NY'},
    { value: '710 3rd Ave', label: '710 3rd Ave, Watervliet, NY'},
    { value: '706 3rd Avenue', label: '706 3rd Avenue, Watervliet, NY'}
]

const beds = [
    { value: '0', label: 'Any' },
    { value: '1', label: '1' },
    { value: '2', label: '2' },
    { value: '3', label: '3' }
]
    
const baths = [
    { value: '0', label: 'Any' },    
    { value: '1', label: '1' },
    { value: '2', label: '2' },
    { value: '3', label: '3' }
]

const availability = [
    { value: '0', label: 'Any' },
    { value: '1', label: 'Available' },
    { value: '2', label: 'Unavailable' },    
]

export default function PropertySearch({ onSelectedPropertyTypeChanged, onSelectedLocationChanged, onSelectedBedroomsChanged, onSelectedBathroomsChanged, onSelectedAvailabilityChanged }) {
    const location = useLocation();
    const navigate = useNavigate();

    const searchParams = new URLSearchParams(location.search);
    const propertySearchTypeURLParam = searchParams.get('propertyType');

    const [selectedPropertyType, setSelectedPropertyType] = useState(propertySearchTypeURLParam);
    const [selectedAddress, setSelectedAddress] = useState('');
    const [selectedBedRooms, setSelectedBedrooms] = useState('0');
    const [selectedBathrooms, setSelectedBathrooms] = useState('0');
    const [selectedAvailability, setSelectedAvailability] = useState('0');
    
    const handleSelectedPropertyTypeChanged = (e) => {
        e.preventDefault();
        if(e.target.attributes['data-propertytype'] === 'undefined') return;
        
        console.log(e.target.attributes);
        setSelectedPropertyType(e.target.attributes['data-propertytype'].value);
    }
    
    const handleSelectedLocationChanged = (selectedOption) =>  
        setSelectedAddress(selectedOption.value);
    
    const handleSelectedBedroomsChanged = (selectedOption) => 
        setSelectedBedrooms(selectedOption.value);

    const handleSelectedBathroomsChanged = (selectedOption) => 
        setSelectedBathrooms(selectedOption.value);

    const handleSelectedAvailabilityChanged = (selectedOption) =>
        setSelectedAvailability(selectedOption.value);
    
    useEffect(() => {
        onSelectedPropertyTypeChanged(selectedPropertyType);
    }, [selectedPropertyType])

    useEffect(() => {
        onSelectedLocationChanged(selectedAddress);
    }, [selectedAddress])

    useEffect(() => {
        onSelectedBedroomsChanged(selectedBedRooms);
    }, [selectedBedRooms])

    useEffect(() => {
        onSelectedBathroomsChanged(selectedBathrooms);
    }, [selectedBathrooms])

    useEffect(() => {
        onSelectedAvailabilityChanged(selectedAvailability);
    }, [selectedAvailability])
    
    return (
        <div className="features-absolute">
            <div className="card search-border-1 bg-white mt-5 property-search">
                <form className="text-start">
                    <div className="registration-form text-dark text-start">
                        <div className="row g-lg-0">
                            <div className="col-lg-2 col-md-3 col-12 center-box">
                                <div className="mb-lg-0 mb-1">
                                    <a className={typeof selectedPropertyType !== 'undefined' && selectedPropertyType === "F" ? 'registration-form selected-search-key' : 'registration-form'} href="/" onClick={handleSelectedPropertyTypeChanged} data-propertytype="F">FURNISHED</a>
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-3 col-12 center-box">
                                <div className="mb-lg-0 mb-1">
                                    <a className={typeof selectedPropertyType !== 'undefined' && selectedPropertyType === "U" ? 'registration-form selected-search-key' : 'registration-form'} href="/" onClick={handleSelectedPropertyTypeChanged} data-propertytype="U">UNFURNISHED</a>
                                </div>
                            </div>
                            {/*<div className="col-lg-2 col-md-3 col-12 center-box">*/}
                            {/*    <div className="mb-lg-0 mb-1">*/}
                            {/*        <a className={typeof selectedPropertyType !== 'undefined' && selectedPropertyType === "SF" ? 'registration-form selected-search-key' : 'registration-form'} href="/" onClick={handleSelectedPropertyTypeChanged} data-propertytype="SF">SEMI-FURNISHED</a>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                            
                            <div className="col-lg-2 col-md-3 col-12 center-box">
                                <div className="mb-lg-0 mb-3">
                                    <Select
                                        classNames={typeof selectedAddress !== 'undefined' && selectedAddress.length > 0 ? 'selected-search-key' : ''}
                                        placeholder="LOCATION"
                                        onChange={handleSelectedLocationChanged} options={locations} 
                                        styles={{
                                            control: (baseStyles, state) => ({
                                                ...baseStyles,
                                                backgroundColor: '#ffffff',
                                                borderColor: '#ffffff',
                                                option: (provided,state) => ({
                                                    ...provided,
                                                    color: '#f97316'                                                    
                                                })
                                            })
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="col-lg-2 col-md-3 col-12 center-box">
                                <div className="mb-lg-0 mb-3">
                                    <Select
                                        id="bedrooms"
                                        className={typeof selectedBedRooms !== 'undefined' && selectedBedRooms !== '0' ? 'selected-search-key' : ''}
                                        placeholder="BEDROOMS"
                                        onChange={handleSelectedBedroomsChanged} 
                                        styles={{
                                            control: (baseStyles, state) => ({
                                                ...baseStyles,
                                                backgroundColor: '#ffffff',
                                                borderColor: '#ffffff'
                                            })
                                        }}
                                        options={beds} />
                                </div>
                            </div>

                            <div className="col-lg-2 col-md-3 col-12 center-box">
                                <div>
                                    <Select
                                        id="bathrooms"
                                        className={typeof selectedBathrooms !== 'undefined' && selectedBathrooms !== '0' ? 'selected-search-key' : ''}
                                        placeholder="BATHROOMS"
                                        onChange={handleSelectedBathroomsChanged} options={baths}
                                        styles={{
                                            control: (baseStyles, state) => ({
                                                ...baseStyles,
                                                backgroundColor: '#ffffff',
                                                borderColor: '#ffffff'
                                            })
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="col-lg-2 col-md-3 col-12 center-box">
                                <div>
                                    <Select
                                        id="availability"
                                        className={typeof selectedAvailability !== 'undefined' && selectedAvailability !== '0' ? 'selected-search-key' : ''}
                                        placeholder="AVAILABILITY"
                                        onChange={handleSelectedAvailabilityChanged} options={availability}
                                        styles={{
                                            control: (baseStyles, state) => ({
                                                ...baseStyles,
                                                backgroundColor: '#ffffff',
                                                borderColor: '#ffffff'
                                            })
                                        }}
                                    />
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </form>
            </div>

        </div>        
    )
}